document.addEventListener("DOMContentLoaded", function () {

  const root = document.querySelector(".sd-page");

  if (!root) return;


  /* =========================================
     SCROLL REVEALS
  ========================================= */

  const revealElements = root.querySelectorAll(".sd-reveal");

  if ("IntersectionObserver" in window) {

    const observer = new IntersectionObserver(
      function (entries) {

        entries.forEach(function (entry) {

          if (entry.isIntersecting) {

            entry.target.classList.add("sd-visible");

            observer.unobserve(entry.target);

          }

        });

      },
      {
        threshold: 0.12,
        rootMargin: "0px 0px -40px 0px"
      }
    );

    revealElements.forEach(function (element) {
      observer.observe(element);
    });

  } else {

    revealElements.forEach(function (element) {
      element.classList.add("sd-visible");
    });

  }


  /* =========================================
     HERO PARALLAX
  ========================================= */

  const hero = root.querySelector(".sd-hero");
  const heroImage = root.querySelector(".sd-hero-image");

  if (
    hero &&
    heroImage &&
    window.matchMedia("(pointer: fine)").matches &&
    !window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {

    hero.addEventListener("mousemove", function (event) {

      const rect = hero.getBoundingClientRect();

      const x = (event.clientX - rect.left) / rect.width - 0.5;
      const y = (event.clientY - rect.top) / rect.height - 0.5;

      heroImage.style.transform =
        "translate(" +
        (x * 10) +
        "px," +
        (y * 10) +
        "px) rotate(2deg)";

    });

    hero.addEventListener("mouseleave", function () {

      heroImage.style.transform =
        "translate(0,0) rotate(2deg)";

    });

  }


  /* =========================================
     PRODUCT CARD MOUSE EFFECT
  ========================================= */

  if (window.matchMedia("(pointer: fine)").matches) {

    root.querySelectorAll(".sd-product").forEach(function (card) {

      card.addEventListener("mousemove", function (event) {

        const rect = card.getBoundingClientRect();

        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        const rotateX =
          ((y / rect.height) - 0.5) * -3;

        const rotateY =
          ((x / rect.width) - 0.5) * 3;

        card.style.transform =
          "translateY(-12px) rotateX(" +
          rotateX +
          "deg) rotateY(" +
          rotateY +
          "deg)";

      });

      card.addEventListener("mouseleave", function () {

        card.style.transform = "";

      });

    });

  }


  /* =========================================
     SMOOTH ANCHORS
  ========================================= */

  root.querySelectorAll('a[href^="#"]').forEach(function (link) {

    link.addEventListener("click", function (event) {

      const targetId = this.getAttribute("href");

      if (!targetId || targetId === "#") return;

      const target = document.querySelector(targetId);

      if (!target) return;

      event.preventDefault();

      target.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });

    });

  });


  /* =========================================
     WHATSAPP
  ========================================= */

  root.querySelectorAll("[data-whatsapp]").forEach(function (button) {

    button.addEventListener("click", function (event) {

      event.preventDefault();

      const number = this.dataset.whatsapp;

      const message =
        this.dataset.message ||
        "Hi Shivlal Dhanawala! I'd like to explore your Mukhwas and Dry Fruits collection.";

      if (!number || number.includes("XXXXXXXX")) {
        alert("Please add the Shivlal Dhanawala WhatsApp number first.");
        return;
      }

      const whatsappURL =
        "https://wa.me/" +
        number +
        "?text=" +
        encodeURIComponent(message);

      window.open(whatsappURL, "_blank");

    });

  });

});